import React, {useContext} from "react";
import "./Education.scss";
import EducationCard from "../../components/educationCard/EducationCard";
import {educationInfo} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext"; // Import StyleContext

export default function Education() {
  const {isDark} = useContext(StyleContext); // Use useContext
  if (educationInfo.display) {
    return (
      <div className="main" id="education"> {/* Added .main wrapper */}
        <div className="education-section-content"> {/* Added this wrapper */}
          <h1 className={isDark ? "dark-mode education-heading" : "education-heading"}>
            Education
          </h1>
          <div className="education-card-container">
            {educationInfo.schools.map((school, index) => (
              <EducationCard key={index} school={school} />
            ))}
          </div>
        </div>
      </div>
    );
  }
  return null;
}
